export const MENU_NAV_EXAM_ID = {
  RMO: 1005,
  IJSO: 1006,
  FOUNDATION_TEST: 1017,
  HOTS: 2001,
  EEP: 2002,
  CBSE: 3001,
  JEE_MAIN: 1001,
  JEE_ADVANCED: 1002,
  NEET: 1003,
  EAPCET: 1004,
  AEEE: 1007,
  MET: 1008,
  MHCET: 1009,
  KIITEE: 1010,
  VITEEE: 1011,
  SRMJEEE: 1012,
  COMEDK: 1013,
  BITSAT: 1014,
  KCET: 1015,
  TN_BOARD: 3003,
} as const;

export const MENU_NAV_ITEM_IDS = [
  "home",
  "live-classes",
  "learn",
  "tests",
  "Doubts",
  "bookmarks",
  "Subscriptions",
  "ReferEarn",
  "contact_us",
  "log_out",
] as const;

export type MenuNavItemId = (typeof MENU_NAV_ITEM_IDS)[number];

export type AndroidNavigationConfigSlice = {
  home: boolean;
  "live-classes": boolean;
  learn: boolean;
  tests: boolean;
  Doubts: boolean;
  bookmarks: boolean;
  Subscriptions: boolean;
  ReferEarn: boolean;
  contact_us: boolean;
  log_out: boolean;
};

export type MenuNavigationFlags = AndroidNavigationConfigSlice;

export type NavigationConfigCore = {
  home: boolean;
  selflearn: boolean;
  tests: boolean;
  liveClass: boolean;
  doubts: boolean;
};

export function navigationConfigToMenuFlags(
  c: NavigationConfigCore,
): MenuNavigationFlags {
  const anyPrimary =
    c.home || c.selflearn || c.tests || c.liveClass || c.doubts;
  return {
    home: c.home,
    "live-classes": c.liveClass,
    learn: c.selflearn,
    tests: c.tests,
    Doubts: c.doubts,
    bookmarks: c.selflearn,
    Subscriptions: anyPrimary,
    ReferEarn: anyPrimary,
    contact_us: true,
    log_out: true,
  };
}

const MENU_NAV_ID_SET = new Set<string>(MENU_NAV_ITEM_IDS);

type Rule = { exams: readonly number[]; flags: MenuNavigationFlags };

type BucketSpec = { rules: readonly Rule[]; fallback: MenuNavigationFlags };

const GRADE_BUCKET_ELSE = "__grade_else__";

const NAV_BUCKETS: Record<string, BucketSpec> = {
  "1,2": {
    rules: [
      {
        exams: [MENU_NAV_EXAM_ID.HOTS],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: true,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
      {
        exams: [MENU_NAV_EXAM_ID.EEP],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: true,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
    ],
    fallback: navigationConfigToMenuFlags({
      home: false,
      selflearn: false,
      tests: true,
      liveClass: false,
      doubts: false,
    }),
  },
  "3": {
    rules: [
      {
        exams: [MENU_NAV_EXAM_ID.HOTS],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: true,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
      {
        exams: [MENU_NAV_EXAM_ID.EEP],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: true,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
    ],
    fallback: navigationConfigToMenuFlags({
      home: true,
      selflearn: true,
      tests: true,
      liveClass: true,
      doubts: true,
    }),
  },
  "4,5": {
    rules: [
      {
        exams: [MENU_NAV_EXAM_ID.CBSE],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: true,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
      {
        exams: [MENU_NAV_EXAM_ID.HOTS],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: true,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
      {
        exams: [MENU_NAV_EXAM_ID.EEP],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: true,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
    ],
    fallback: navigationConfigToMenuFlags({
      home: true,
      selflearn: true,
      tests: true,
      liveClass: true,
      doubts: true,
    }),
  },
  "6,7": {
    rules: [
      {
        exams: [MENU_NAV_EXAM_ID.IJSO],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: false,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
      {
        exams: [MENU_NAV_EXAM_ID.HOTS],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: true,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
      {
        exams: [MENU_NAV_EXAM_ID.EEP],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: true,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
    ],
    fallback: navigationConfigToMenuFlags({
      home: true,
      selflearn: true,
      tests: true,
      liveClass: true,
      doubts: true,
    }),
  },
  "8": {
    rules: [
      {
        exams: [MENU_NAV_EXAM_ID.RMO],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: false,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
      {
        exams: [MENU_NAV_EXAM_ID.IJSO],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: false,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
      {
        exams: [MENU_NAV_EXAM_ID.HOTS],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: true,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
    ],
    fallback: navigationConfigToMenuFlags({
      home: true,
      selflearn: true,
      tests: true,
      liveClass: true,
      doubts: true,
    }),
  },
  "9,10": {
    rules: [
      {
        exams: [MENU_NAV_EXAM_ID.RMO],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: false,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
      {
        exams: [MENU_NAV_EXAM_ID.IJSO],
        flags: navigationConfigToMenuFlags({
          home: true,
          selflearn: false,
          tests: true,
          liveClass: true,
          doubts: false,
        }),
      },
    ],
    fallback: navigationConfigToMenuFlags({
      home: true,
      selflearn: true,
      tests: true,
      liveClass: true,
      doubts: true,
    }),
  },
  [GRADE_BUCKET_ELSE]: {
    rules: [],
    fallback: navigationConfigToMenuFlags({
      home: true,
      selflearn: true,
      tests: true,
      liveClass: true,
      doubts: true,
    }),
  },
};

function ruleExamsSatisfiedByUser(
  user: Set<number>,
  ruleExams: readonly number[],
): boolean {
  return ruleExams.length > 0 && ruleExams.every((e) => user.has(e));
}

export function getMenuNavigationGradeBucket(
  gradeId: number | null | undefined,
): string {
  if (gradeId == null || !Number.isFinite(Number(gradeId))) {
    return GRADE_BUCKET_ELSE;
  }
  const g = Number(gradeId);
  if (g === 1 || g === 2) return "1,2";
  if (g === 3) return "3";
  if (g === 4 || g === 5) return "4,5";
  if (g === 6 || g === 7) return "6,7";
  if (g === 8) return "8";
  if (g === 9 || g === 10) return "9,10";
  return GRADE_BUCKET_ELSE;
}

export function isNonVerticalOne(
  verticalId: number | null | undefined,
): boolean {
  if (verticalId == null) return false;
  const v = Number(verticalId);
  return Number.isFinite(v) && v !== 1;
}

/**
 * @deprecated Use {@link isNonVerticalOne}. Name kept for older call sites; behavior matches.
 */
export function isVerticalTwoOrThree(
  verticalId: number | null | undefined,
): boolean {
  return isNonVerticalOne(verticalId);
}

export function getMenuNavigationFlags(
  gradeId: number | null | undefined,
  examIds: readonly number[],
  verticalId?: number | null,
): MenuNavigationFlags {
  const user = new Set(
    examIds.map((x) => Number(x)).filter((n) => Number.isFinite(n) && n > 0),
  );
  const bucket = getMenuNavigationGradeBucket(gradeId);
  const spec = NAV_BUCKETS[bucket] ?? NAV_BUCKETS[GRADE_BUCKET_ELSE];
  let base: MenuNavigationFlags = spec.fallback;
  for (const rule of spec.rules) {
    if (ruleExamsSatisfiedByUser(user, rule.exams)) {
      base = rule.flags;
      break;
    }
  }
  if (isNonVerticalOne(verticalId)) {
    return { ...base, Subscriptions: false, ReferEarn: false };
  }
  return base;
}

export type EnrolledProgramLike = {
  gradeId?: number;
  mdsGradeId?: number;
  examId?: number;
  mdsExamId?: number;
  exams?: unknown;
  exam_ids?: unknown;
  isDefault?: boolean;
  [key: string]: unknown;
};

function firstPositiveNumber(...candidates: unknown[]): number | null {
  for (const c of candidates) {
    const n = Number(c);
    if (Number.isFinite(n) && n > 0) return n;
  }
  return null;
}

export function getGradeIdFromEnrolledProgram(
  program: EnrolledProgramLike | null | undefined,
): number | null {
  if (!program) return null;
  const p = program as Record<string, unknown>;
  const gradeObj = p.grade;
  const nested =
    gradeObj && typeof gradeObj === "object"
      ? (gradeObj as Record<string, unknown>)
      : null;

  return firstPositiveNumber(
    program.mdsGradeId,
    p.mds_grade_id,
    nested?.mdsGradeId,
    nested?.mds_grade_id,
    program.gradeId,
    p.grade_id,
    nested?.gradeId,
    nested?.grade_id,
  );
}

export function getVerticalIdFromEnrolledProgram(
  program: EnrolledProgramLike | null | undefined,
): number | null {
  if (!program) return null;
  const p = program as Record<string, unknown>;
  const nestedGrade =
    p.grade && typeof p.grade === "object"
      ? (p.grade as Record<string, unknown>)
      : null;
  return firstPositiveNumber(
    p.vertical_id,
    p.verticalId,
    nestedGrade?.vertical_id,
    nestedGrade?.verticalId,
  );
}

export function collectExamIdsFromEnrolledProgram(
  program: EnrolledProgramLike | null | undefined,
): number[] {
  if (!program) return [];
  const p = program as Record<string, unknown>;
  const out = new Set<number>();
  const add = (v: unknown) => {
    const n = Number(v);
    if (Number.isFinite(n) && n > 0) out.add(n);
  };
  add(program.mdsExamId);
  add(program.examId);
  add(p.mds_exam_id);
  add(p.exam_id);

  const list =
    program.exam_ids ??
    program.exams ??
    p.exam_ids ??
    (Array.isArray(p.examIds) ? p.examIds : undefined);
  if (Array.isArray(list)) {
    for (const e of list) {
      if (typeof e === "number" || typeof e === "string") {
        add(e);
      } else if (e && typeof e === "object") {
        const o = e as Record<string, unknown>;
        add(o.examId);
        add(o.exam_id);
        add(o.mdsExamId);
        add(o.mds_exam_id);
        add(o.id);
      }
    }
  }
  return [...out];
}

export function isMenuItemVisibleForNavigationFlags(
  menuId: string,
  flags: MenuNavigationFlags,
): boolean {
  if (MENU_NAV_ID_SET.has(menuId)) {
    return flags[menuId as MenuNavItemId];
  }
  return true;
}

export type WebBottomNavTabKey = "home" | "play" | "library" | "todo";

export function isWebBottomNavTabVisible(
  tab: WebBottomNavTabKey,
  flags: MenuNavigationFlags,
): boolean {
  switch (tab) {
    case "home":
      return flags.home;
    case "play":
      return flags["live-classes"];
    case "library":
      return flags.learn;
    case "todo":
      return flags.tests;
    default:
      return true;
  }
}

export const WEB_BOTTOM_NAV_TAB_ORDER = [
  "home",
  "play",
  "library",
  "todo",
] as const satisfies readonly WebBottomNavTabKey[];

export const WEB_BOTTOM_NAV_ROUTE_PATHS: Record<WebBottomNavTabKey, string> = {
  home: "/dashboard",
  play: "/courses",
  library: "/self-learn",
  todo: "/tests",
};

export function getFirstVisibleWebBottomNavTab(
  flags: MenuNavigationFlags,
): WebBottomNavTabKey {
  for (const tab of WEB_BOTTOM_NAV_TAB_ORDER) {
    if (isWebBottomNavTabVisible(tab, flags)) {
      return tab;
    }
  }
  return flags.tests ? "todo" : "home";
}

const WEB_BOTTOM_NAV_PATH_ROOT = {
  tests: "tests",
  selfLearn: "self-learn",
  courses: "courses",
  liveClasses: "live-classes",
  dashboard: "dashboard",
} as const;

export function pathnameToWebBottomNavTab(
  pathname: string,
): WebBottomNavTabKey | null {
  const raw = (pathname.split("?")[0] ?? pathname).replace(/\/+$/, "") || "/";
  const p = raw.startsWith("/") ? raw : `/${raw}`;
  const segments = p.split("/").filter(Boolean);
  const first = segments[0] ?? "";

  if (first === WEB_BOTTOM_NAV_PATH_ROOT.tests) {
    return "todo";
  }
  if (first === WEB_BOTTOM_NAV_PATH_ROOT.selfLearn) {
    return "library";
  }
  if (first === WEB_BOTTOM_NAV_PATH_ROOT.courses) {
    return "play";
  }
  if (first === WEB_BOTTOM_NAV_PATH_ROOT.liveClasses) {
    return "play";
  }
  if (p === "/" || first === WEB_BOTTOM_NAV_PATH_ROOT.dashboard) {
    return "home";
  }
  return null;
}

export function applyMenuNavigationVisibility<
  T extends { id: string; visible: boolean },
>(
  items: readonly T[],
  gradeId: number | null | undefined,
  examIds: readonly number[],
  verticalId?: number | null,
): T[] {
  const flags = getMenuNavigationFlags(gradeId, examIds, verticalId);
  return items.map((item) => ({
    ...item,
    visible: isMenuItemVisibleForNavigationFlags(item.id, flags),
  }));
}
